module.exports = __webpack_public_path__ + "static/media/tda3000kz.f800fdb0.pdf";